import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import { AppBar, Container, Popover, Toolbar, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import { ConfigOptionsContext } from "../../../components/newPortal/NewPortalLayout";
import { useState } from "react";
import "./progressBar.css";
import { ConfigurationDashboardOptions } from "../../../components/configurationDashboardOptions/configurationDashboardOptions";

const steps = [
  "Register Through Micro Site",
  // "Onboarding",
  "Feature Selection",
  "Config Setup",
  "Data Upload",
  // "Final App",
];

export interface ProgressBarPropsTypes {
  handleStepIconClick: (stepNumber: number) => void;
  currentStep: number;
  optional?: string | null;
  completed: { [k: number]: boolean };
  setCompleted: React.Dispatch<
    React.SetStateAction<{
      [k: number]: boolean;
    }>
  >;
}

export default function ProgressBar(props: ProgressBarPropsTypes) {
  const { completed, setCompleted, currentStep, handleStepIconClick, optional } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  // Set the initial completed state on mount
  React.useEffect(() => {
    setCompleted((prev) => ({
      ...prev,
      0: true,
    }));
  }, [setCompleted]);

  const [activeStep, setActiveStep] = React.useState(currentStep || 1);
  React.useEffect(() => {
    // if(optional!==null){
    //   setActiveStep(2);
    //   return;
    // }
    setActiveStep(currentStep || 1);
  }, [currentStep,optional,activeStep]);

  

  const handleStep = (step: number) => () => {
    if (step === 0 || (step !== activeStep && !completed[step])) {
      return;
    }

    if (completed[step] || step === 0) {
      handleStepIconClick(step);
      setActiveStep(step);
    }
  };

  const stepperStyles = {
    "& .MuiStepIcon-root": {
      fontSize: 26,
    },
    "& .MuiStepLabel-label": {
      fontSize: 14,
    },
    "& .Mui-active .MuiStepConnector-line": {
      borderColor: "#23c6b0",
    },
    "& .Mui-completed .MuiStepIcon-root": {
      color: "#23c6b0",
    },
    "& .Mui-completed .MuiStepConnector-line": {
      borderColor: "#23c6b0",
    },
    "& .MuiStepConnector-line": {
      borderColor: "#eaeaf0",
    },
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: "#ffffff", height: "8vh", minHeight: "70px" }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <Box sx={{ width: "100%" }}>
            <div className="navbar-header">
              <img
                alt="logo"
                src="/static/media/SALESCODE_LOGO.8147fbca8faba22447ca.png"
                className="headerLogo"
              />
              <Stepper
                nonLinear
                activeStep={activeStep}
                style={{ width: "100%" }}
                sx={stepperStyles}
              >
                {steps.map((label, index) => (
                  <Step key={label} completed={completed[index]}>
                    {index < steps.length - 1 ? (
                      <StepButton color="inherit" onClick={handleStep(index)}>
                      {label}
                      </StepButton>
                    ) : (
                      <StepButton
                        // icon={
                        //   <StarIcon
                        //     sx={{
                        //       color: "#F6AB27",
                        //       border: "1px solid #E6E6E6",
                        //       backgroundColor: activeStep === index ? "#227C9D" : "white",
                        //       borderRadius: "50%",
                        //       fontSize: 20,
                        //       padding: "1px"
                        //     }}
                        //   />
                        // }
                        onClick={handleStep(index)}
                      >
                        {label}
                      </StepButton>
                    )}
                  </Step>
                ))}
              </Stepper>
              <div
                onClick={handlePopoverOpen}
                style={{
                  lineHeight: 0
                }}
              >
                <MoreVertOutlinedIcon
                  sx={{
                    color: "#1C7EA0",
                    backgroundColor: "#227C9D33",
                    borderRadius: "50%",
                    fontSize: "30px",
                    padding: "5px",
                  }}
                />
              </div>
              <ConfigurationDashboardOptions id={id} anchorEl={anchorEl} handleClose={handlePopoverClose} disableChangePassword />
            </div>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}